// extracted by mini-css-extract-plugin
export default {"banksList":"BanksList_banksList__3Z1ct","isLoadingBanksList":"BanksList_isLoadingBanksList__LL4dL","note":"BanksList_note__XDgdl","loader":"BanksList_loader__DbwK6"};